import { useNavigation } from '@refinedev/core';
import { Button } from '../button';
import { AppstoreOutlined } from '@ant-design/icons';

type CreateButtonProps = {
    resource?: string;
    label?: string;
    icon?: React.ReactNode;
    variant?: 'primary' | 'secondary' | 'small';
    children?: React.ReactNode;
    onClick?: () => void;
    className?: string;
};

export const CreateButton = ({
    resource = 'applications',
    label = 'Створити',
    icon = null,
    variant = 'small',
    className,
    ...props
}: CreateButtonProps) => {
    const { create } = useNavigation();

    const handleGo = () => {
        if (props?.onClick) {
            props.onClick();
        } else {
            create(resource);
        }
    };

    return (
        <Button
            icon={icon}
            onClick={handleGo}
            variant={variant}
            className={className}
        >
            {label}
        </Button>
    );
};
